import styled from "styled-components"

const RadioContainer = styled.div`
  display: inline-block;
  position: relative;
  margin: 0 0 10px;
  font-size: 16px;
  line-height: 24px;

  cursor: pointer;
`

const RadioLabel = styled.label`
  display: block;
  padding: 0 0 0 24px;
  cursor: pointer;

  :before {
    content: "";
    position: absolute;
    top: 4px;
    left: 0;
    width: 16px;
    height: 16px;
    background-color: transparent;
    border: 1px solid var(--color-blue-600);
    border-radius: 14px;
    z-index: 1;
    transition: border-color 0.28s
      cubic-bezier(0.4, 0, 0.2, 1);
  }

  :after {
    content: "";
    position: absolute;
    top: 8px;
    left: 4px;
    width: 8px;
    height: 8px;
    background-color: var(--color-primary-500);
    border-radius: 50%;
    z-index: 2;
    transform: scale(0, 0);
    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  }
`

const RadioInput = styled.input`
  position: absolute;
  top: 4px;
  left: 0;
  width: 36px;
  height: 20px;
  opacity: 0;
  z-index: 0;

  cursor: pointer;

  &:checked + ${RadioLabel}:before {
    border-color: var(--color-primary-500);
  }

  &:checked + ${RadioLabel}:after {
    transform: scale(1, 1);
  }
`

interface RadiosProps {
  labels: string[]
  name: string
  checked: number
  onChange?: (index: number) => void
}

const Radios = (props: RadiosProps) => {
  return (
    <>
      {props.labels.map((label, index) => (
        <RadioContainer key={index}>
          <RadioInput
            onChange={() =>
              props.onChange && props.onChange(index)
            }
            type="radio"
            name={props.name}
            id={props.name + index}
            defaultChecked={index === props.checked}
          />
          <RadioLabel htmlFor={props.name + index}>
            {label}
          </RadioLabel>
        </RadioContainer>
      ))}
    </>
  )
}

export default Radios
